module.exports = __webpack_public_path__ + "img/status-created-active.197697da.svg";